import React from 'react';

const AddressDisplayName: React.FC<{display_name: string}> = ({display_name}) =>
  display_name ? <React.Fragment>{display_name}</React.Fragment> : null;

export default AddressDisplayName;
